import ContentConfig from '../ContentConfig';

/**
 * @param config - configuration to check
 * @returns true if the configuration has a minimal config to get a real config
 */
export default function isValidConfig(config?: ContentConfig): boolean {
  return !!config?.ch;
}
